import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Meta from '../components/Meta';
import './LegalPages.css';

function Impressum() {
  const { t } = useTranslation();

  return (
    <div className="legal-page-wrapper">
      <Meta
        title={`${t('legal.impressum.title')} | Vorpoint`}
        description={t('legal.impressum.subtitle')}
      />
      <section className="legal-hero">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="legal-hero-badge">{t('legal.impressum.badge')}</div>
          <h1>{t('legal.impressum.title')}</h1>
          <p>{t('legal.impressum.subtitle')}</p>
        </motion.div>
      </section>

      <motion.div
        className="legal-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <div className="legal-card">
          <div className="legal-card-icon">🏢</div>
          <h2>{t('legal.impressum.provider')}</h2>
          <p>
            <strong>Vorpoint</strong><br />
            Ahmed Tahhan<br />
            Gorkistraße 84<br />
            04347 Leipzig<br />
            Deutschland
          </p>
        </div>

        <div className="legal-card">
          <div className="legal-card-icon">📞</div>
          <h2>{t('legal.impressum.contact')}</h2>
          <p>
            Telefon: <a href="tel:+491778663796">+49-1778663796</a><br />
            E-Mail: <a href="mailto:info@vorpoint.de">info@vorpoint.de</a><br />
            Web: <a href="https://www.vorpoint.de">www.vorpoint.de</a>
          </p>
        </div>

        <div className="legal-card">
          <div className="legal-card-icon">💼</div>
          <h2>{t('legal.impressum.vat_title')}</h2>
          <p>
            {t('legal.impressum.vat_text')}
          </p>
        </div>

        <div className="legal-card">
          <div className="legal-card-icon">✍️</div>
          <h2>{t('legal.impressum.responsible')}</h2>
          <p>
            Ahmed Tahhan<br />
            Gorkistraße 84<br />
            04347 Leipzig
          </p>
        </div>

        <div className="legal-card">
          <div className="legal-card-icon">🔗</div>
          <h2>{t('legal.impressum.links_title')}</h2>
          <p>
            {t('legal.impressum.links_text')}
          </p>
        </div>

        <div className="legal-card">
          <div className="legal-card-icon">©️</div>
          <h2>{t('legal.impressum.copyright_title')}</h2>
          <p>
            {t('legal.impressum.copyright_text')}
          </p>
        </div>

        <div className="legal-card legal-card-dispute">
          <div className="legal-card-icon">⚖️</div>
          <h2>{t('legal.impressum.dispute_title')}</h2>
          <p>
            {t('legal.impressum.dispute_text_1')}{' '}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr
            </a>
          </p>
          <p>
            {t('legal.impressum.dispute_text_2')}
          </p>
        </div>
      </motion.div>
    </div>
  );
}

export default Impressum;